import { BriefingHistorySentDateModel } from './briefing-history-sent-date.model';

export class BriefingHistorySentModel {
    total: number;
    briefingId: number;
    sentDates: BriefingHistorySentDateModel[];
}
